import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserProfile } from '../models/user-profile.model';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor(
    private http: HttpClient
  ) { }

  shopeepayCreateOrder(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/shopeepay/create-order', JSON.stringify(item));
  }

  gCashCreateOrder(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/gcash/create-order', JSON.stringify(item));
  }

  mayaCreateOrder(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/maya/create-order', JSON.stringify(item));
  }

  orderHistory(): Observable<any> {
    return this.http
      .get<UserProfile>(environment.apiUrl + '/v2/tokens/order-history');
  }

  checkOrderStatus(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/tokens/check-status', JSON.stringify(item));
  }

  cancelShopeePayOrder(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/shopeepay/invalidate-order', JSON.stringify(item));
  }

  cancelGcashOrder(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/gcash/invalidate-order', JSON.stringify(item));
  }

  getPassCreateOrder(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/points/create-order', JSON.stringify(item));
  }
}
